// API Endpoints
export const API_BASE_URL = "http://localhost:5000/api";

// Auth
export const LOGIN_ENDPOINT = "/auth/login";
export const LOGOUT_ENDPOINT = "/auth/logout";
export const ME_ENDPOINT = "/auth/me";

// Users
export const USERS_ENDPOINT = "/users";
export const USER_BY_ID_ENDPOINT = (id) => `/users/${id}`;
export const USERS_DROPDOWN_ENDPOINT = "/users/users-dropdown";

// File System
export const FILESYSTEM_STRUCTURE_ENDPOINT = "/filesystem/structure";
export const FILESYSTEM_FOLDERS_ENDPOINT = "/filesystem/folders";
export const FILESYSTEM_FILES_ENDPOINT = "/filesystem/files";
export const FILESYSTEM_ITEMS_ENDPOINT = "/filesystem/items";
export const FILESYSTEM_MY_LIBRARY_ENDPOINT = "/filesystem/my-library";
export const FILESYSTEM_ITEM_BY_ID_ENDPOINT = (id) => `/filesystem/items/${id}`;
export const FILESYSTEM_ITEM_RENAME_ENDPOINT = (id) =>
  `/filesystem/items/${id}/rename`;
export const FILESYSTEM_ITEM_MOVE_ENDPOINT = (id) =>
  `/filesystem/items/${id}/move`;
export const FILESYSTEM_FOLDER_BY_ID_ENDPOINT = (id) =>
  `/filesystem/folders/${id}`;
export const FILESYSTEM_SEARCH_ENDPOINT = (query) =>
  `/filesystem/search?query=${encodeURIComponent(query)}`;
export const FILESYSTEM_FILE_DOWNLOAD_ENDPOINT = (id, disposition = "auto") =>
  `/filesystem/files/${id}/download?disposition=${disposition}`;

// Add more as needed...

export const PROMPTS_PROCESS_ENDPOINT = "/prompts/process";
